import * as THREE from 'three'
import Experience from '../Experience.js'
import { Float32Attribute, MathUtils } from 'three'

export default class Cloud
{
    constructor(index)
    {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.time = this.experience.time;
        this.increment = 20;
        this.resource = this.resources.items.cloudModel;
        this.world = this.experience.world;
        this.setTextures();
        this.setMaterial();
        this.setModel(index);
    }

    setTextures()
    {
        this.textures = {}
        this.textures.main = this.resources.items.cloudTexture;
        this.textures.main.flipY = false;
    }

    setMaterial()
    {
        this.islandMaterial = new THREE.MeshBasicMaterial({
            map: this.textures.main
        })
    }

    setModel(index)
    {
        this.model = this.resource.scene.clone(true);
        this.model.traverse((child)=>
        {                
            child.material = this.islandMaterial;                    
        })
        this.model.position.x = this.CalcLinearPos(index).x;
        this.model.rotateY( (Math.PI / this.world.islandCount) * index)
        this.scene.add(this.model);
    }

    CalcLinearPos(index)
    {
        const position = new THREE.Vector3()
        position.x = this.increment*index
        position.y = 0
        position.z = 0
        return position
    }

    update()
    {        
        //console.log(this.time.delta);
        this.model.rotation.y += (this.time.delta * 0.00002)
    }
}